import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  AfterViewChecked,
  OnDestroy,
  AfterViewInit,
  EventEmitter,
  Output,
  Input,
  ElementRef,
} from "@angular/core";
import { NgForm } from "@angular/forms";
import { Checklist, WizardStep } from "src/app/core/components";
import { UserManagementService } from "../user-management.service";
import * as _ from "lodash";
import { Subscription } from "rxjs";
import { SharedService } from "src/app/core/services";
import { Router, ActivatedRoute } from "@angular/router";
import { CommonApiService } from "src/app/common/common-api.service";
import { TradeMasterParams } from "src/app/common/common-api.model";
import { GLOBAL } from "src/app/app.globals";
import { DynamicApicallService } from "src/app/service/dynamic-apicall.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ManPowerService } from "src/app/man-power/man-power.service";
import { sectionList } from "src/app/man-power/man-power.modal";
import { ApiCallService } from "src/app/service/api-call.service";
import { LogHelperService } from "src/app/core/services/log-helper.service";

@Component({
  selector: "app-create-user-info",
  templateUrl: "./create-user-info.component.html",
  styleUrls: ["./create-user-info.component.css"],
})
export class CreateUserInfoComponent
  implements OnInit, AfterViewChecked, OnDestroy, AfterViewInit {
  @Input() userData: any;
  @Input() editMode: boolean;
  formChangesSubscription: Subscription;
  @Output() closeModal: EventEmitter<string>;
  @ViewChild("userInfoForm") userInfoForm: NgForm;
  checkList: Checklist[] = [];
  wizardSteps: WizardStep[] = [];
  roleMasterData = [];
  designationMasterData = [];
  // organizationMasterData = [];
  sectionTreeList: any[] = [];
  workmanCategoryList: any[] = [];
  manPowerTypeList: any[] = [];
  private selectedSectionList: any[] = [];
  sectionList: any[] = sectionList;
  unitDepartmentSectionTreeData: any[] = [];
  // organizationAll = [];
  // organizationCopy = [];
  errcuserConfirmpassword = false;
  erruserpassword = false;
  selectedOrg = [];
  userCode = "";
  @ViewChild('firstName') firstName: ElementRef;
  user = {
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    alias: '',
    role: null,
    isOrganization: '',
  };
  mobileNumber: string = '';
  role: string = '';
  selectedLanguage: string = '';
  selectedDesignation: string = '';
  selectedTimeZone: string = '';
  languageData = [];
  timezoneData = [];
  accessPermissionTree = [];
  designation = [];
  userId: string;
  userIdP: any;
  // organizationcode: any;
  companycode: any;
  plantcode: any;
  departmentcode: any;
  designationcode: any;
  rolecode: any;
  departmentSectionList = [];
  selectedRoles = [];
  selectedRoleCodes = [];
  tradeMasterParams: TradeMasterParams;
  loginUserId: any;
  private manPowerObj = {};

  public set manPower(value: any) {
    if (value) {
      this.manPowerObj = value;
    }
  }

  public get manPower(): any {
    return this.manPowerObj;
  }

  constructor(
    private userManagementService: UserManagementService,
    private ref: ChangeDetectorRef,
    private router: Router,
    private manPowerService: ManPowerService,
    private route: ActivatedRoute,
    public modalService: NgbActiveModal,
    private apiCall: ApiCallService,
    private logHelperService: LogHelperService,
    private sharedService: SharedService,
    private activatedRoute: ActivatedRoute,
    private commonApiService: CommonApiService
  ) {
    this.loginUserId = localStorage.getItem("userId")
      ? localStorage.getItem("userId")
      : 0;

    this.tradeMasterParams = {
      UserId: this.loginUserId,
    };
  }

  ngAfterViewChecked() {
    this.ref.detectChanges();
  }

  stepChange($event) {
    if ($event.nextStep === 1) {
      this.selectedRoles = this.roleMasterData.filter(
        (item) => this.selectedRoleCodes.indexOf(item.Role_Code) > -1
      );
    }
  }

  setSectionData(sections) {
    // this.enumerateDaysBetweenDates(moment)
    for (const section of sections) {
      for (const workmanCategory of section.workmanCategoryList) {
        for (const shift of workmanCategory.shiftList) {
          shift.data = [];

        }
      }
    }
    this.sectionList = sections;
  }

  private getManpowerType(): void {
    this.manPowerService.getMasterItemByCode(GLOBAL.MASTER_ITEM_CODE.MANPOWER_TYPE).subscribe((response: any[]) => {
      this.manPowerTypeList = response;
    });
  }
  private getWorkManCategoryList(): void {
    this.manPowerService.getMasterItemByCode(GLOBAL.MASTER_ITEM_CODE.WORKMAN_CATEGORY).subscribe((response: any[]) => {
      this.workmanCategoryList = response;
      if (this.userInfoForm && this.workmanCategoryList) {
        if (this.manPower.CategoryWorkmenMIL_Code) {
          this.userInfoForm.form.get('CategoryWorkmenMIL_Code').setValue(this.manPower.CategoryWorkmenMIL_Code);
        } else if (this.workmanCategoryList.length === 1) {
          this.userInfoForm.form.get('CategoryWorkmenMIL_Code').setValue(this.workmanCategoryList[0].MasterItem_Code);
        }
      }
    });
  }


  isValidEmail = false
  isValidUserCode = false
  ngAfterViewInit() {
    this.userIdP = this.route.snapshot.paramMap.get("id");
    this.getDepartmentSectionList();

  }

  checkDuplicate(field: 'email' | 'userCode', value: string): void {
    const reqObj = {
      AlternetEmailID: field === 'email' ? value : null,
      UserCode: field === 'userCode' ? value : null,
      Action: 0,
      RequestType: field === 'email' ? 1 : 2,
      RequestedUserID: GLOBAL.USER_ID,
    };

    this.apiCall.userInfoDuplicateCheck(reqObj).subscribe((res: any) => {
      if (res[0].Status == "Exist" && field == "email") {
        this.isValidEmail = false
      } else if (res[0].Status == "Not-Exist" && field == "email") {
        this.isValidEmail = true
      }

      if (res[0].Status == "Exist" && field == "userCode") {
        this.isValidUserCode = false
      } else if (res[0].Status == "Not-Exist" && field == "userCode") {
        this.isValidUserCode = true
      }
    });
  }

  showMobileError: boolean = false;

checkValidOrNot(value: string) {
  const cleaned = value.replace(/\s/g, '');
  this.showMobileError = cleaned.length !== 10 || !/^\d{10}$/.test(cleaned);
}

  designationError() {
    let flag = false;
    if (
      this.userInfoForm.controls.designation.dirty ||
      this.userInfoForm.controls.designation.touched
    ) {
      flag = !this.designationValidation();
    } else {
      flag = false;
    }
    return flag;
  }

  onCloseAction() {
    this.modalService.close(); // This will close the modal
  }

  onSelectSection(data): void {
    this.selectedSectionList = data;
  }

  createShiftSectionList(shifts: any[]): void {
    const sections = [];
    const selectedWorkmanCategoryList: any[] = [];
    const workmanCategory = this.manPower.CategoryWorkmenMIL_Code;
    if (workmanCategory) {
      workmanCategory.forEach((workmanCategoryCode: any) => {
        const categoryItem = this.workmanCategoryList.find((item: any) => item.MasterItem_Code === workmanCategoryCode);
        if (categoryItem) {
          selectedWorkmanCategoryList.push(
            {
              id: workmanCategoryCode,
              name: categoryItem.Name
            }
          );
        }
      });
    }
    this.selectedSectionList.forEach((section: any) => {
      const sectionItem = {
        Id: section.id,
        Name: section.itemName,
        workmanCategoryList: [],
      };
      selectedWorkmanCategoryList.forEach((workmanCategory: any) => {
        sectionItem.workmanCategoryList.push(
          {
            CategoryWorkmenMIL_Code: workmanCategory.id,
            workmanCategoryName: workmanCategory.name,
            shiftList: _.cloneDeep(shifts.filter(s => s.WorkmenCategoryMIT_Code === workmanCategory.id)),
            Date: [],
          },
        );
      });
      sections.push(sectionItem);
    });
    this.setSectionData(sections);
  }

  designationValidation() {
    let flag = false;
    if (
      this.userInfoForm.form.controls.designation.value === "" ||
      this.userInfoForm.form.controls.designation.value === null
    ) {
      flag = false;
    } else {
      flag = true;
    }
    return flag;
  }

  async ngOnInit() {
    this.formChangesSubscription =
      this.userInfoForm.form.valueChanges.subscribe((form) => {

      });

    await this.userManagementService
      .getUserRoleList()
      .subscribe((roleData: any) => {
        let globalSettingData = GLOBAL.GLOBALCODES.find(i => i.Code === "MOD145G100ROLL");
        let allowedRoleCodes: number[] = [];
        if (globalSettingData && globalSettingData.Value) {
          allowedRoleCodes = globalSettingData.Value.split(',').map(code => +code);
        }

        const filteredRoles = roleData.filter(role =>
          allowedRoleCodes.includes(role.Role_Code)
        );

        this.roleMasterData = filteredRoles;

        if (this.roleMasterData.length === 1) {
          this.role = this.roleMasterData[0].Role_Code;
          this.onChangeRoles(this.role);
        }

      });

    this.getManpowerType();
    this.getWorkManCategoryList();
    await this.userManagementService


    await this.commonApiService
      .getAllTradeMaster(this.tradeMasterParams)
      .subscribe((designationData: any) => {
        this.designationMasterData = designationData;
        if (this.designationMasterData.length === 1) {
          this.selectedDesignation = this.designationMasterData[0].Trade_code;
        }
      });

    await this.userManagementService
      .getLanguageData()
      .subscribe((data: any) => {
        this.languageData = data;
        if (this.languageData.length === 1) {
          this.selectedLanguage = this.languageData[0].Language_Code;
        }
      });

    this.userManagementService.actionPermission().subscribe((data: any) => {
      this.accessPermissionTree = this.bindModuleList(data);
    });

    this.getTimeZone();
    if (this.editMode && this.userData) {
      this.userResMpping(this.userData)
    }
  }

  getTimeZone() {
    const reqObj = {
      "Search": null
    }

    this.apiCall.getTimeZonelist(reqObj).subscribe((res) => {
      this.timezoneData = res

      if (this.timezoneData.length === 1) {
        this.selectedTimeZone = this.timezoneData[0].TimeZone_Code;
      }
    });
  }

  bindModuleList(accessPermissionData) {
    const moduleData = [];
    if (accessPermissionData.modules.length) {
      accessPermissionData.modules.forEach((element) => {
        const pageListData = element.pages;
        const obj = Object.assign(
          {},
          {
            moduleId: element.moduleId,
            moduleName: element.moduleName,
          }
        );
        // tslint:disable-next-line:max-line-length
        moduleData.push({
          value: element.moduleId,
          text: element.moduleName,
          checked: false,
          children: this.bindPageList(
            pageListData,
            obj,
            accessPermissionData.actions
          ),
        });
      });
    }
    return moduleData;
  }

  bindPageList(pageListData, moduleObj, actionList) {
    const pageListModel = [];
    if (pageListData.length > 0) {
      pageListData.forEach((element) => {
        const selectedActionId = element.selectedActionIds;
        const pageObj = Object.assign({}, moduleObj);
        pageObj["pageId"] = element.pageId;
        pageObj["pageName"] = element.pageName;
        // tslint:disable-next-line:max-line-length
        pageListModel.push({
          value: element.pageId,
          text: element.pageName,
          moduelId: moduleObj.moduleId,
          checked: false,
          children: this.bindActionList(selectedActionId, pageObj, actionList),
        });
      });
    }
    return pageListModel;
  }

  bindActionList(selectedActionIds, pageObj, actionList) {
    const actionListData = [];
    if (actionList.length > 0) {
      actionList.forEach((element) => {
        const flag =
          selectedActionIds.indexOf(element.actionId) > -1 ? true : false;
        const pageAction = Object.assign({}, pageObj);
        pageAction["actionId"] = element.actionId;
        actionListData.push({
          value: pageAction,
          text: element.actionName,
          checked: flag,
          children: [],
        });
      });
    }
    return actionListData;
  }

  onFilterChange(value: string) {
    console.log("filter:", value);
  }

  // bindOrganizationEdit() {
  //   this.organizationMasterData = this.bindDataOrganization(
  //     this.organizationAll
  //   );
  //   this.organizationCopy = this.organizationMasterData;
  // }

  // bindDataOrganization(filteredData) {
  //   const convertedData = [];
  //   filteredData.forEach((val, key) => {
  //     const subDataFilter = val.CompanyViews;
  //     if (subDataFilter.length > 0) {
  //       // tslint:disable-next-line:max-line-length
  //       convertedData.push({
  //         id: val.Organization_Code,
  //         organizationCode: val.Organization_Code,
  //         name: val.Name,
  //         currentname: "organization",
  //         isActive: false,
  //         selected: false,
  //         children: this.bindDataCompany(subDataFilter, val.Organization_Code),
  //       });
  //     } else {
  //       // tslint:disable-next-line:max-line-length
  //       convertedData.push({
  //         id: val.Organization_Code,
  //         organizationCode: val.Organization_Code,
  //         name: val.Name,
  //         currentname: "organization",
  //         isActive: false,
  //         selected: false,
  //       });
  //     }
  //   });
  //   return convertedData;
  // }

  bindDataCompany(filteredData, organizationCode) {
    const convertedData = [];
    filteredData.forEach((val: any, key) => {
      const subDataFilter = val.Plantviews;
      if (subDataFilter.length > 0) {
        // tslint:disable-next-line:max-line-length
        convertedData.push({
          id: val.Company_Code,
          companyCode: val.Company_Code,
          name: val.Name,
          // tslint:disable-next-line:object-literal-shorthand
          organizationCode: organizationCode,
          currentname: "Company",
          isActive: false,
          selected: false,
          children: this.bindDataPlants(
            subDataFilter,
            organizationCode,
            val.Company_Code
          ),
        });
      } else {
        // tslint:disable-next-line:max-line-length
        convertedData.push({
          id: val.Company_Code,
          companyCode: val.Company_Code,
          name: val.Name,
          // tslint:disable-next-line:object-literal-shorthand
          // organizationCode: organizationCode,
          currentname: "Company",
          isActive: false,
          selected: false,
        });
      }
    });
    return convertedData;
  }

  bindDataPlants(filteredData, organizationCode, companyCode) {
    const convertedData = [];
    filteredData.forEach((val, key) => {
      const subDataFilter = val.DepartmentViews;
      if (subDataFilter.length > 0) {
        // tslint:disable-next-line:max-line-length
        convertedData.push({
          id: val.Plant_Code,
          plantCode: val.Plant_Code,
          name: val.Name,
          // tslint:disable-next-line:object-literal-shorthand
          organizationCode: organizationCode,
          companyCode: companyCode,
          currentname: "Plant",
          isActive: false,
          selected: false,
          children: this.bindDataDepartments(
            subDataFilter,
            organizationCode,
            companyCode,
            val.Plant_Code
          ),
        });
      } else {
        // tslint:disable-next-line:max-line-length
        convertedData.push({
          id: val.Plant_Code,
          plantCode: val.Plant_Code,
          name: val.Name,
          // tslint:disable-next-line:object-literal-shorthand
          organizationCode: organizationCode,
          companyCode: companyCode,
          currentname: "Plant",
          isActive: false,
          selected: false,
        });
      }
    });
    return convertedData;
  }

  bindDataDepartments(filteredData, organizationCode, companyCode, plantCode) {
    const convertedData = [];
    filteredData.forEach((val, key) => {
      // tslint:disable-next-line:max-line-length
      convertedData.push({
        id: val.Department_Code,
        departmentCode: val.Department_Code,
        name: val.Name,
        // tslint:disable-next-line:object-literal-shorthand
        organizationCode: organizationCode,
        companyCode: companyCode,
        plantCode: plantCode,
        currentname: "Department",
        isActive: false,
        selected: false,
      });
    });
    return convertedData;
  }

  userResMpping(data) {
    
    //     "Role": ",104,105,106,107,108,109,110,111,115,118,119,120,121",
    

    this.userCode = data.UserCode
    const fullName = data.FullName.trim();
    const nameParts = fullName.split(' ');

    if (nameParts.length === 1) {
      this.user.firstName = nameParts[0];
      this.user.middleName = '';
      this.user.lastName = '';
    } else if (nameParts.length === 2) {
      this.user.firstName = nameParts[0];
      this.user.middleName = '';
      this.user.lastName = nameParts[1];
    } else if (nameParts.length >= 3) {
      this.user.firstName = nameParts[0];
      this.user.middleName = nameParts.slice(1, nameParts.length - 1).join(' ');
      this.user.lastName = nameParts[nameParts.length - 1];
    }

    this.user.email = data.AlternetEmailID;
    this.mobileNumber = data.MobileNo;
    this.selectedTimeZone = data.TimeZone_Code;
    // this.user.alias = data.UserName;
    this.user.role = +data.Role.split(',').filter(x => x.trim())[0];
    this.user.isOrganization = data.IsOrganizationUser;


  }


  async onSubmit(formData) {

    if (formData.userCode == null || formData.userCode == "") {
      this.logHelperService.logError({
        message: 'Please first fullfill UserCode.'
      });
      return
    }

    if (formData.firstName == null || formData.firstName == "") {
      this.logHelperService.logError({
        message: 'Please first fullfill firstName.'
      });
      return
    }

    if (formData.email == null || formData.email == "") {
      this.logHelperService.logError({
        message: 'Please first fullfill email.'
      });
      return
    }

    if (formData.userConfirmpassword == null || formData.userConfirmpassword == "") {
      this.logHelperService.logError({
        message: 'Please first fullfill Confirm Password.'
      });
      return
    }

    if (formData.userpassword == null || formData.userpassword == "") {
      this.logHelperService.logError({
        message: 'Please first fullfill Password.'
      });
      return
    }

    if (formData.mobileNo == null || formData.mobileNo == "") {
      this.logHelperService.logError({
        message: 'Please first fullfill Mobile Number.'
      });
      return
    }

    if (formData.role == null || formData.role == "" || formData.role.length === 0) {
      this.logHelperService.logError({
        message: 'Please first select any role.'
      });
      return
    }

    const user = {
      UserCode: formData.userCode,
      UserName: formData.email,
      FirstName: formData.firstName,
      MiddleName: formData.middleName,
      LastName: formData.lastName,
      Password: formData.userpassword,
      AlternetEmailID: formData.email,
      MobileNo: formData.mobileNo,
      Alias: formData.alias,
      Language_Code: formData.language,
      Designation_Code: Number(formData.designation.join(',')),
      TimeZone_Code: formData.TimeZone_Code,
      IsOrganizationUser: formData.isOrganization,
      Role: formData.role.join(','),
      SectionPlantID: null,
      RequireType: 0,
      Action: 0,
      UserId: Number(GLOBAL.USER_ID)
    };

    // user["role"] = formData.role;
    // user["UserDepartmentSections"] = [];
    // this.selectedOrg.filter((val) => {
    //   const userDeprt = {};
    //   userDeprt["Organization_Code"] = val[0].organizationCode;
    //   userDeprt["Company_Code"] = val[0].companyCode;
    //   userDeprt["Plant_Code"] = val[0].plantCode;
    //   userDeprt["Department_Code"] = val[0].departmentCode;
    //   userDeprt["User_Code"] = this.userCode;
    //   user["UserDepartmentSections"].push(userDeprt);
    // });
    if (this.editMode) {
      await this.userManagementService
        .updateUser(user)
        .subscribe((result: any) => {
          if (result === "Success") {
            // this.router.navigate(["user-list"]);
            this.modalService.close();
          }
        });
    } else {
      await this.userManagementService
        .addUser(user)
        .subscribe((result: any) => {
          if (result.Data.Message === "UserInformation Added Successfully!") {
            // this.router.navigate(["user-list"]);
            this.modalService.close();
          }
        });
    }
  }

  clearForm() {
    // const userCode = this.userCode;
    this.userInfoForm.reset();
    // setTimeout(() => {
    //   this.userCode = userCode;
    // }, 200);
  }

  userpasswordChange() {
    const userInfoForm = this.userInfoForm.form.value;
    if (userInfoForm.userpassword !== userInfoForm.userpassword) {
      this.erruserpassword = true;
    } else {
      this.erruserpassword = false;
    }
  }

  confirmpasswordChange(event) {
    const userInfoForm = this.userInfoForm.form.value;
    if (userInfoForm.userpassword !== userInfoForm.userConfirmpassword) {
      this.errcuserConfirmpassword = true;
    } else {
      this.errcuserConfirmpassword = false;
    }
  }
  eOrg(data) {
    let items = [];
    if (data && data.length > 0) {
      this.selectedOrg.push(items);
      this.selectedOrg = _.uniqWith(this.selectedOrg, _.isEqual);
    }
  }

  findAll(data, items) {
    let found;
    let result = [];
    items.filter((res) => {
      if (res.id === data.id && res.name === data.name) {
        result.push(res);
      } else if (_.isArray(res.children)) {
        found = this.findAll(data, res.children);
        if (found.length) {
          result = result.concat(found);
        }
      }
    });
    return result;
  }

  onAutoGeneratePassword() {
    const pswd = this.sharedService.generateRandomPassword(10);
    this.userInfoForm.form.controls["userpassword"].setValue(pswd);
    this.userInfoForm.form.controls["userConfirmpassword"].setValue(pswd);
  }

  ngOnDestroy(): void {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    this.formChangesSubscription.unsubscribe();
  }

  getDepartmentSectionList(): void {
    this.userManagementService.getDepartmentSectionList().subscribe((res) => {
      this.departmentSectionList = res;
    });
  }

  onChangeRoles(roles): void {
    this.selectedRoleCodes = roles;
  }

  public onCancel() {
    // this.router.navigate(["user-management/user-list"]);
    this.modalService.close();
  }
}
